<template>
  <div class="worldofzain">
    <Header></Header>
        <div class="landing">
            <div class="container">
                <div class="section-title">
                    <h1>{{$t("labels.worldofzain")}}</h1> 
                </div>
                <div class="select-cotinent">
                    <div class="cotinent">
                        <div class="image east">
                            <img src="@/assets/images/svg/middle-east.svg" alt="middle-east" class="img-fluid">
                        </div>
                        <div class="name">{{$t("labels.middleEast")}}</div>
                        <router-link :to="`/${$i18n.locale}/world-of-zain/middleeast`" class="abs-link"></router-link>
                    </div>
                    <div class="cotinent">
                        <div class="image africa">
                            <img src="@/assets/images/svg/africa.svg" alt="africa" class="img-fluid">
                        </div>
                        <div class="name">{{$t("labels.africa")}}</div>
                        <router-link :to="`/${$i18n.locale}/world-of-zain/africa`" class="abs-link"></router-link>
                    </div>
                </div>
            </div>
        </div>
  </div>
</template>

<script>
import { gsap } from "gsap";
import animation from '@/mixin/animation'
export default {
    mixins:[animation],
    mounted(){
        this.titleAnimation();
        setTimeout(() => {
            gsap.fromTo(".cotinent",{autoAlpha: 0, y: "-50%"},{autoAlpha: 1,y:0, duration:0.6, ease: Power1.easeIn});
        }, 2000);
        
    }
}
</script>
<style>
[data-page='worldofzain']{
    min-height: 100vh;
    overflow: hidden;
}
</style>
<style lang="scss" scoped>

.worldofzain{
    min-height: 100vh;
    overflow: hidden;
    position:relative;
    &:after{
        content:"";
        position:absolute;
        width:100%;
        height:100%;
        background: url("../assets/images/banners/worldofzain.jpg") center center no-repeat;
        background-attachment: fixed;
        background-size: cover;
        left:0;
        top:0;
        z-index:-1;

    }
    .landing {
        height: 100vh;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        line-height: normal;
        @media screen and (max-width: 991px) {
            padding-bottom: 40px;
        }
    }
    .section-title {
        margin-top: rem(100px);
        text-align: center;
    }
    h1{
        font-size: rem(80px);
        font-weight: 800;
        color:#fff;
        text-transform: uppercase;
        visibility: hidden; 
        margin-bottom: rem(100px);
        text-align: center;
        display: inline-block;
        @media screen and (max-width: 1600px){
            font-size: rem(50px);
            margin-bottom: rem(45px);
        }
         @media screen and (max-width: 991px){
           font-size: rem(35px);
           margin-bottom: rem(30px);
        }
    }
    .select-cotinent {
        display: flex;
        // margin-left: rem(75px);
        justify-content: center;
        overflow: hidden;
        @media screen and (max-width: 575px){
            flex-direction: column;
            text-align: center;
            justify-content: center;
        }
        .cotinent {
            text-align: center;
            position: relative;
            visibility: hidden;
            // transition: .3s all ease-in;
            &:first-child {
                margin-right: rem(175px);
                @media screen and (max-width: 1600px){
                    margin-right: rem(90px);
                }
                @media screen and (max-width: 991px){
                    margin-right: rem(20px);
                }
                @media screen and (max-width: 575px){
                    margin-right: rem(0px);
                    margin-bottom: 25px;
                }
            }
            .image {
                width: 245px;
                @media screen and (max-width: 991px){
                    width: 175px;
                }
                @media screen and (max-width: 575px){
                    margin-left: auto;
                    margin-right: auto;
                }
            }
            .africa {
                &.image { 
                    width: 345px;
                    @media screen and (max-width: 991px){
                        width: 250px;
                    }
                }
            }
            .name {
                font-size: rem(22px);
                color: #ffffff;
                font-weight: 700;
                margin-top: rem(25px);
                opacity: 0;
                visibility: hidden;
                transition: .3s all ease-in;
                @media screen and (max-width: 991px){
                    opacity: 1;
                    visibility: visible;
                }
            }
            &:hover {
                 .name {
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }
    
}


[lang="ar"]{
    .worldofzain{
        &:after{
            transform: scaleX(-1);
        }
        .select-cotinent {
            .cotinent {
                &:first-child {
                    margin-left: rem(175px);
                    margin-right:0;
                    @media screen and (max-width: 1600px){
                        margin-left: rem(90px);
                        margin-right:0;
                    }
                    @media screen and (max-width: 991px){
                        margin-left: rem(20px);
                        margin-right:0;
                    }
                    @media screen and (max-width: 575px){
                        margin-left: rem(0px);
                    }
                }
            }
        }
        
    }
}

</style>